/** The song itself is not downloadable: Suno's CDN says the public render does
 * not exist for that ID. Publishing in Suno is the user's actual fix, so this
 * is the only message that may open the "how to publish" guide. */
export const SUNO_IMPORT_ERROR =
  "Could not import that Suno song. Publish the song in Suno and make sure the link is public, then try again.";

/** We never got far enough to learn whether the song is public — the request to
 * Suno timed out, failed at the socket, or was refused by their edge. Telling
 * the user to publish an already-published song sends them in circles (observed
 * 2026-09-12: users retried the same public link 6x in 2 minutes), so say what
 * actually happened and point at the workaround that does not involve Suno. */
/** The SAME song was refused by Suno's CDN again after the user was told to
 * publish it. Prod, week to Sep 20 2026: 171 users hit the publish message,
 * 129 retried the same links (up to 9x), and a third never got a song in by
 * any path within 24h — while 58 recovered by uploading the file. So the
 * second refusal stops repeating "publish" and leads with the path that
 * always works. Deliberately NOT equal to SUNO_IMPORT_ERROR: the client opens
 * the publishing guide only on that exact string, and looping it is the
 * failure mode this exists to end. */
export const SUNO_IMPORT_ERROR_REPEAT =
  "Suno still is not serving a public file for this song, so publishing alone may not fix it. Fastest path: open the song on suno.com, use Download, then upload that file here.";

export const SUNO_UNAVAILABLE_ERROR =
  "Could not reach Suno to fetch that song — this is on our side, not yours. Try again in a few minutes, or download the audio from Suno and upload the file here.";

export function isSunoAudioUrl(rawUrl: string): boolean {
  try {
    const { hostname, protocol } = new URL(rawUrl);
    return (
      (protocol === "https:" || protocol === "http:") &&
      ["suno.com", "suno.ai"].some(
        (domain) => hostname === domain || hostname.endsWith(`.${domain}`),
      )
    );
  } catch {
    return false;
  }
}
